import { useAuthorGroupRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetAuthorGroupCommonInfoQuery } from "../../features/articles/articlesSlice";

export { useAuthorGroupRoutes };

export default GetDefaultIndex({ title: "گروه‌های نویسندگان", query: useGetAuthorGroupCommonInfoQuery });
